import React, { useState, useEffect } from "react";
import Header from "../../Components/Header/Header";
import Select from "react-select";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { privateRequest } from "../../Components/commonApi/CommonApi";
import CustomImage from "../CustomImage/CustomImage";

function Newprovider() {
  const [selectedFile, setSelectedFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);

  const [selectedFile1, setSelectedFile1] = useState(null);
  const [imagePreview1, setImagePreview1] = useState(null);

  const [selectedFile2, setSelectedFile2] = useState(null);
  const [imagePreview2, setImagePreview2] = useState(null);

  const [selectedFile3, setSelectedFile3] = useState(null);
  const [imagePreview3, setImagePreview3] = useState(null);

  const [selectedFile4, setSelectedFile4] = useState(null);
  const [imagePreview4, setImagePreview4] = useState(null);

  const [selectedFile5, setSelectedFile5] = useState(null);

  const [imagePreview5, setImagePreview5] = useState(null);

  const [parentCategory, setParentCategoryGroups] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);

  const [name, setName] = useState("");
  const [Email, setEmail] = useState("");
  const [Phone, setPhone] = useState("");
  const [DOB, setDOB] = useState("");
  const [Gender, setGender] = useState("");
  const [State, setState] = useState("");
  const [Address, setAddress] = useState("");
  const [City, setCity] = useState("");
  const [Type, setType] = useState("");
  const [ExpertType, setExpertType] = useState("prime");
  const [Password, setPassword] = useState("");
  const [Status, setStatus] = useState("");
  const navigate = useNavigate();

  const GetParentCatory = async () => {
    try {
      const response = await privateRequest.get(`/Service/CombineApis`);
      setParentCategoryGroups(response?.data?.data?.ParentGroup);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append("Name", name);
      formData.append("Emailid", Email);
      formData.append("ContactNo", Phone);
      formData.append("DOB", DOB);
      formData.append("Gender", Gender);
      formData.append("State", State);
      formData.append("address", Address);
      formData.append("Password", Password);
      formData.append("city", City);
      formData.append("Provider_Type", Type);
      formData.append("expertType", ExpertType);
      formData.append("ProfilePhoto", selectedFile ? selectedFile : "");
      formData.append("AdharCard", selectedFile1 ? selectedFile1 : "");
      formData.append("PAN_Card", selectedFile2 ? selectedFile2 : "");
      formData.append("Driving_Lience", selectedFile3 ? selectedFile3 : "");
      formData.append("HighSchool", selectedFile4 ? selectedFile4 : "");
      formData.append("Other_document", selectedFile5 ? selectedFile5 : "");
      selectedGroup.forEach((group) => {
        formData.append("PCGroup", group.value);
      });
      formData.append("Status", Status);

      if (!name) {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "Please fill name",
        });
        return;
      }
      if (!Phone) {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "Please fill Mobile Number",
        });
        return;
      }
      if (!DOB) {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "Please fill date of birth",
        });
        return;
      }

      // if (!Gender || Address || Password || City || selectedGroup) {
      //   Swal.fire({
      //     icon: "error",
      //     title: "Error!",
      //     text: "Please fill all feilds",
      //   });
      //   return;
      // }
      const response = await privateRequest.post(
        "ServiceProvider/AddProvider",
        formData
      );
      console.log("Provider created successfully:", response.data);
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Provider added successfully!",
      });
      navigate("/serviceprovider");
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Failed to add data.",
      });
      console.error("Error creating service:", error);
    }
  };

  useEffect(() => {
    GetParentCatory();
  }, []);

  return (
    <div className="app has-fullwidth">
      <main className="app-main">
        <div className="wrapper">
          <div className="page">
            <div className="page-inner">
              <div className="container-fluid">
                <header className="page-title-bar">
                  <div className="d-flex flex-column flex-md-row">
                    <p className="lead mb-0">
                      <span className="font-weight-bold">Service Provider</span>
                    </p>
                  </div>
                </header>

                <div className="page-section">
                  <div className="card" style={{ borderRadius: "15px" }}>
                    <div className="card-body">
                      <form onSubmit={handleSubmit}>
                        <div className=" row pb-0 mb-0">
                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Name</label>
                              <input
                                type="text"
                                id="inputgroupName"
                                className="form-control"
                                placeholder="Name"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                              />
                            </div>
                          </div>
                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Email-Id</label>
                              <input
                                type="text"
                                id="inputgroupName"
                                className="form-control"
                                placeholder="EmailId"
                                value={Email}
                                onChange={(e) => setEmail(e.target.value)}
                              />
                            </div>
                          </div>
                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Phone No</label>
                              <input
                                type="Number"
                                id="inputgroupName"
                                className="form-control"
                                placeholder="Phone No"
                                value={Phone}
                                onChange={(e) => setPhone(e.target.value)}
                              />
                            </div>
                          </div>
                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Provider Type</label>
                              <input
                                type="text"
                                id="inputgroupName"
                                className="form-control"
                                placeholder="Type"
                                value={Type}
                                onChange={(e) => setType(e.target.value)}
                              />
                            </div>
                          </div>
                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Expert Type</label>
                              <select
                                className="form-control"
                                value={ExpertType}
                                onChange={(e) => setExpertType(e.target.value)}
                                required
                              >
                                <option value="prime">Prime Expert</option>
                                <option value="gold">Gold Expert</option>
                              </select>
                            </div>
                          </div>
                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Date of Birth</label>
                              <input
                                type="Date"
                                id="inputgroupName"
                                className="form-control"
                                placeholder="Date of Birth"
                                value={DOB}
                                onChange={(e) => setDOB(e.target.value)}
                              />
                            </div>
                          </div>
                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Gender</label>
                              <select
                                className="form-control"
                                value={Gender}
                                onChange={(e) => setGender(e.target.value)}
                              >
                                <option value="">Select</option>
                                <option value="male">Male</option>
                                <option value="female">Female</option>
                                <option value="other">Other</option>
                              </select>
                            </div>
                          </div>
                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>City </label>
                              <input
                                type="text"
                                id="inputgroupName"
                                className="form-control"
                                placeholder="City"
                                value={City}
                                onChange={(e) => setCity(e.target.value)}
                              />
                            </div>
                          </div>
                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Address</label>
                              <input
                                type="text"
                                id="inputgroupName"
                                className="form-control"
                                placeholder="Address"
                                value={Address}
                                onChange={(e) => setAddress(e.target.value)}
                              />
                            </div>
                          </div>

                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>State</label>
                              <input
                                type="text"
                                id="inputgroupName"
                                className="form-control"
                                placeholder="State"
                                value={State}
                                onChange={(e) => setState(e.target.value)}
                              />
                            </div>
                          </div>

                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Password</label>
                              <input
                                type="text"
                                id="inputgroupName"
                                className="form-control"
                                placeholder="Password"
                                value={Password}
                                onChange={(e) => setPassword(e.target.value)}
                              />
                            </div>
                          </div>
                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Parent Category Group</label>
                              <Select
                                placeholder={"Parent Category Group"}
                                isMulti
                                options={parentCategory.map((group) => ({
                                  value: group._id,
                                  label: group.PCGName,
                                }))}
                                onChange={(selectedOptions) =>
                                  setSelectedGroup(selectedOptions)
                                }
                                value={selectedGroup}
                              />
                            </div>
                          </div>

                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Status</label>
                              <select
                                className="form-control"
                                value={Status}
                                onChange={(e) => setStatus(e.target.value)}
                              >
                                <option value="">Select</option>
                                <option value="1">Active</option>
                                <option value="0">Inactive</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="row mt-4">
                          <div className="col-6 col-lg-2 text-center">
                            <CustomImage
                              setImagePreview={setImagePreview}
                              imagePreview={imagePreview}
                              setSelectedFile={setSelectedFile}
                              imageName={"Select Profile Photo"}
                              imageCount={"img1"}
                            />
                          </div>
                          <div className="col-6 col-lg-2 text-center">
                            <CustomImage
                              setImagePreview={setImagePreview1}
                              imagePreview={imagePreview1}
                              setSelectedFile={setSelectedFile1}
                              imageName={"Upload Aadhar Card"}
                              imageCount={"img2"}
                            />
                          </div>
                          <div className="col-6 col-lg-2 text-center">
                            <CustomImage
                              setImagePreview={setImagePreview2}
                              imagePreview={imagePreview2}
                              setSelectedFile={setSelectedFile2}
                              imageName={"Upload Pan Card"}
                              imageCount={"img3"}
                            />
                          </div>

                          <div className="col-6 col-lg-2 text-center">
                            <CustomImage
                              setImagePreview={setImagePreview3}
                              imagePreview={imagePreview3}
                              setSelectedFile={setSelectedFile3}
                              imageName={"Upload Driving Lience"}
                              imageCount={"img4"}
                            />
                          </div>

                          <div className="col-6 col-lg-2 text-center">
                            <CustomImage
                              setImagePreview={setImagePreview4}
                              imagePreview={imagePreview4}
                              setSelectedFile={setSelectedFile4}
                              imageName={"Upload High School"}
                              imageCount={"img5"}
                            />
                          </div>

                          <div className="col-6 col-lg-2 text-center">
                            <CustomImage
                              setImagePreview={setImagePreview5}
                              imagePreview={imagePreview5}
                              setSelectedFile={setSelectedFile5}
                              imageName={"Upload Other Document"}
                            />
                          </div>
                        </div>

                        <div className="row mt-3">
                          <div className="col-lg-12">
                            <button
                              type="submit"
                              className="btn btn-primary btn-sm ml-auto"
                            >
                              <i className="famr-2"></i>Create Provider
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default Newprovider;
